import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { MEDIA_TYPES } from '../../../lib/constants';
import { mutateSetBlacklisted } from '../../../lib/gqlRequests';
import { requestDataLoader } from '../../../lib/requestDataLoader';
import { GlobalState } from '../../../lib/types';
import { TextSolidButton } from '../../buttons';
import { LoadingAnimation } from '../../LoadingAnimation';
import { ContentHeader, PopupWindow } from '../../wrappers';
import { ContentState } from '../../../lib/types';
import { SET_CONTENT_STATE } from '../../../store/store';

export const ActivateTracksCheckout = (props: {
  close: () => void;
  mediaType: MEDIA_TYPES;
}) => {
  const { close } = props;
  const dispatch = useDispatch();

  const [startedLoad, setStartedLoad] = useState(false);
  const { searchResult, selectedIds } = useSelector<GlobalState, ContentState>(
    (state) => state.content[props.mediaType]
  );

  const tracks: { id: number; name: string }[] = searchResult
    .filter((r) => selectedIds.has(r.id))
    .map((r) => ({ id: r.id, name: r.name }));

  const [activateTrackStatuses, setActivateTrackStatuses] = useState(
    tracks.map((track) => ({
      id: track.id,
      name: track.name,
      loading: false,
      error: null as Error | null,
      data: false,
    }))
  );

  const loaders = activateTrackStatuses.map((status, i) =>
    requestDataLoader({
      identifier: `activateTracks/${props.mediaType}/${status.id}`,
      initialValue: false,
      doRequest: () =>
        mutateSetBlacklisted({
          trackId: status.id,
          blacklisted: false,
          removeFromQueues: false,
        }),
      formatResponse: (res) => true,
      onStateChange: (output) => {
        activateTrackStatuses[i] = {
          ...activateTrackStatuses[i],
          data: output.data,
          error: output.error,
          loading: output.loading,
        };

        if (output.data) {
          searchResult.forEach((row) => {
            if (row.id === status.id) {
              row.isBlacklisted = false;
            }
          });

          dispatch({
            type: SET_CONTENT_STATE[props.mediaType],
            data: {
              searchResult: [...searchResult],
            },
          });
        }

        setActivateTrackStatuses([...activateTrackStatuses]);
      },
    })
  );

  return (
    <PopupWindow>
      <div>
        Activate {tracks.length} tracks? They will be available in Portal Search
      </div>
      <table style={{ width: '100%' }}>
        <tbody>
          {activateTrackStatuses.map(({ id, name, data, error, loading }) => (
            <tr key={id}>
              <td style={{ whiteSpace: 'nowrap' }}>{name}</td>
              <td>
                <LoadingAnimation
                  sizePx={20}
                  animate={loading}
                  color={
                    data
                      ? 'darkgreen'
                      : loading
                      ? 'orange'
                      : error
                      ? 'tomato'
                      : 'black'
                  }
                />
              </td>
              <td>{data ? 'Done' : loading ? 'Loading' : error || 'TODO'}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div>
        <ContentHeader>
          {startedLoad || (
            <TextSolidButton
              text="Confirm"
              onClick={() => {
                setStartedLoad(true);
                loaders.forEach((l) => l.load());
              }}
            />
          )}
          <TextSolidButton
            text="Back"
            onClick={() => {
              close();
            }}
          />
        </ContentHeader>
      </div>
    </PopupWindow>
  );
};
